import React, {Component, useEffect, useState} from 'react';
import Dialog from '../../../../../commonModules/interface/Dialog';
import Photos from '../../../../../commonModules/interface/input-files';
import {isEmpty} from "lodash";
import {TextArea} from '../../../../../commonModules/interface/form-input-inline';
import {Button, Box} from '@material-ui/core';
import InputText,{ InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';

const TransfertStockOccasion = (props) => {
    const [shopList,setShopList] = useState([])
    const [price,setPrice] = useState(0)
    const [selectShop, setSelectShop] = useState("");
    const [selectShopDisplay, setSelectShopDisplay] = useState({
        value: "",
        label: "Tous les Magasins",
    });
    useEffect(() => {
        const list = createShopList()
        setShopList(list)
    }, []);

    const createShopList = () => {
        const SHOPS = props.SHOPS
        const list = [{ value: "", label: "Tous les Magasins" }];
        if (SHOPS) {
            Object.values(SHOPS).map((shop) => {
                list.push({ value: shop.id, label: shop.name , disabled: (props.sav.sav_shop_id === shop.id || !!shop.shop_disabled)});
            });
        }
        return list;
    };

    const validate = () => {
        const required = ["comments"]
        let noErrors = true
        let errors = {}
        required.map(field => {
            if (props[field] === "") {
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }

        })
        if (noErrors) {
            props.submitAll()
        }
    }

    return (
        <Dialog
            block={true}
            title="Transfert de Stock occasion"
            submitAction={validate}
            submitTitle="Valider"
            close={props.closeForms}>
            <Box>
            <InputSelectMagasin
                    options={shopList}
                    value={selectShopDisplay}
                    label="Sélectionner un Magasin"
                    onChange={(option) => {
                        setSelectShopDisplay(option);
                        setSelectShop(option.value);
                        props.handleChange({
                            target: {
                            name: 'comments',
                            value: option.value
                          }})
                    }}
                    maxWidth
                />
                <InputText 
                        value={price} 
                        name="price" 
                        onChange={props.handleChange} 
                        type="number"
                        title="Coût de l'opération"
                    />
            </Box>
        </Dialog>
    );
}

export default TransfertStockOccasion;
